// extracted by mini-css-extract-plugin
export var aniSpin = "D_d";
export var back = "D_6";
export var date = "D_7";
export var excerpt = "D_8";
export var head = "D_5";
export var heading = "D_F";
export var post = "D_9";
export var readmore = "D_bb";